import { AdjustmentFilter as PixiAdjustmentFilter } from 'pixi-filters';
import { assertNumberBetween } from '../../validators';
import { Config } from '../../video-data/config';
import type { BaseSettings } from '../TimeAwareBase';
import { Filter } from './Filter';

export class AdjustmentFilter extends Filter {
    override _classType = Config.ADJUSTMENT_FILTER;
    override pixiFilter: PixiAdjustmentFilter;

    constructor(settings: BaseSettings) {
        super(settings);
        this.pixiFilter = new PixiAdjustmentFilter();
    }

    override get propertiesToSerialize() {
        return super.propertiesToSerialize.concat(['brightness', 'contrast']);
    }

    get brightness(): number {
        return this.pixiFilter.brightness;
    }

    set brightness(value: number) {
        if (value === this.pixiFilter.brightness) {
            return;
        }
        assertNumberBetween(value, 0, Infinity);
        this.pixiFilter.brightness = value;
        this.requiresUpdate = true;
    }

    get contrast(): number {
        return this.pixiFilter.contrast;
    }

    set contrast(value: number) {
        if (value === this.pixiFilter.contrast) {
            return;
        }
        assertNumberBetween(value, 0, Infinity);
        this.pixiFilter.contrast = value;
        this.requiresUpdate = true;
    }
}
